<script module lang="ts">
  import Layout from '../components/Layout.svelte'
  import { translate } from '../i18n'
  import type { Locale } from '../translations'

  export const layout = (props: { locale: Locale }) => ({
    component: Layout,
    props: { title: translate(props.locale, 'footer.imprint') },
  })
</script>

<script lang="ts">
  import LegalPage from '../components/LegalPage.svelte'
  import OperatorAddress from '../components/OperatorAddress.svelte'
  import OperatorEmail from '../components/OperatorEmail.svelte'
  import { getI18n } from '../i18n'

  const i18n = getI18n()
</script>

<LegalPage title={i18n.t('footer.imprint')}>
  <h2 class="imprint-heading">{i18n.t('imprint.provider.heading')}</h2>
  <OperatorAddress />

  <h2 class="imprint-heading">{i18n.t('imprint.contact.heading')}</h2>
  <p class="imprint-email-label">{i18n.t('imprint.contact.email')}:</p>
  <OperatorEmail />

  <h2 class="imprint-heading">{i18n.t('imprint.responsible.heading')}</h2>
  <OperatorAddress />
</LegalPage>

<style>
  .imprint-heading {
    margin-top: var(--space-10);
  }

  .imprint-email-label {
    margin-bottom: 0;
  }
</style>
